import { render } from "./UserBadge.vue?vue&type=template&id=9b91cfba&scoped=true"
import script from "./UserBadge.vue?vue&type=script&lang=js"
export * from "./UserBadge.vue?vue&type=script&lang=js"

import "./UserBadge.vue?vue&type=style&index=0&id=9b91cfba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b91cfba"]])

export default __exports__